// =====================================================================
// src/modulos/intercorrencias.js — as intercorrências da IMOBILIÁRIA (0099)
//
// O chamado que a manutenção do hotel não resolveu e a supervisão
// encaminhou à imobiliária do flat. Ela não tem aba de Manutenção (Hugo,
// 02/11/2026: "Card + sino"): o card "Intercorrências N pendentes" do
// Dashboard abre este modal.
//
// DE ONDE VEIO O DESENHO, linha a linha do MdM (index.html):
//   · o card: `_dashKpiCard` (2250), na fila de `_dashRenderKpis` (2340);
//   · o modal: `modalIntercorrencias` (23271) — título vermelho com a
//     contagem, botão "Histórico (N)", lista com rolagem, "Fechar";
//   · o cartão: `_renderIntercorrenciaItem` (23291) — fundo #fff5f5 e borda
//     #fca5a5 (verde quando resolvido), "Flat N" no cabeçalho (aqui "Quarto N", como no resto do app), data em 11px
//     cinza, foto acima da descrição, "Resolvida? Não / Sim";
//   · o histórico: `modalIntercorrenciasHistorico` (23377).
//
// ONDE DIVERGE, E POR QUÊ:
//   · "Sim" pede uma observação (opcional) antes de fechar — Hugo, 02/11:
//     "Sim pede observação". É ela que vira o histórico (`resolver_chamado`).
//   · "Não" não grava nada, como lá (no painel pendente é informativo).
//   · A foto: o bucket daqui é PRIVADO (0029/0083); o cartão mostra o botão
//     "Ver foto" e pede a URL assinada só quando alguém clica.
//   · No histórico, sem "Reabrir" e sem "Excluir": quem encerra o chamado é
//     o fluxo da manutenção, e a imobiliária não apaga registro do hotel.
//   · Além do texto da camareira, o cartão mostra o motivo da supervisão
//     ("o que a imobiliária precisa fazer"), que lá não existe.
//
// QUEM VÊ O QUÊ não está aqui: `chamados_do_cliente` (0099) devolve à
// imobiliária só os escalados dos flats dela.
// =====================================================================
import { el, icone, abrirModal, fecharModal, aviso } from '../ui.js';
import { separarIntercorrencias } from '../lib/manutencao.js';

const quando = iso => (iso ? new Date(iso).toLocaleString('pt-BR',
  { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');
const ic = (nome, w, extra = {}) => { const i = icone(nome); Object.assign(i.style, { width: w + 'px', height: w + 'px' }, extra); return i; };


export function abrirIntercorrencias({ auth, linhas, aoMudar }) {
  const { pendentes, resolvidas } = separarIntercorrencias(linhas);

  function cartao(c) {
    const resolvida = c.situacao === 'resolvido';
    const corCab = resolvida ? '#059669' : '#dc2626';
    const caixa = el('div', { class: 'intercorrencia', dataset: { chamado: c.id, quarto: c.unidade },
      style: { background: resolvida ? '#f0fdf4' : '#fff5f5', border: resolvida ? '1px solid #86efac' : '1.5px solid #fca5a5',
               borderRadius: '10px', padding: '12px 14px', marginBottom: '10px' } });
    caixa.appendChild(el('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px', marginBottom: '8px', flexWrap: 'wrap' } },
      el('div', { style: { fontSize: '13px', fontWeight: '700', color: corCab, display: 'inline-flex', alignItems: 'center', gap: '6px' } },
        ic(resolvida ? 'ic-check' : 'ic-warning', 14, { color: corCab }), `Quarto ${c.unidade}`),
      el('div', { style: { fontSize: '11px', color: '#6b7280' } }, quando(c.escalado_em || c.aberto_em))));
    if (c.escalado_motivo) caixa.appendChild(el('div', { class: 'motivo-supervisao', style: { fontSize: '12px', fontWeight: '600', color: '#b45309', marginBottom: '6px' } },
      `A supervisão do hotel: ${c.escalado_motivo}`));
    if (c.foto_caminho) {
      const lugar = el('div', { style: { marginBottom: '8px' } });
      const ver = el('button', { type: 'button', class: 'btn btn-secondary btn-sm', dataset: { foto: c.id },
        onclick: async () => {
          ver.disabled = true;
          try {
            const url = await auth.urlAssinada('intercorrencias', c.foto_caminho, 300);
            lugar.replaceChildren(el('img', { src: url, alt: 'Foto da intercorrência',
              style: { maxWidth: '100%', maxHeight: '180px', borderRadius: '6px', display: 'block', border: '1px solid #e5e7eb' } }));
          } catch (e) { aviso(e.message, 'erro'); ver.disabled = false; }
        } }, ic('ic-camera', 12, { verticalAlign: '-2px', marginRight: '4px' }), 'Ver foto');
      lugar.appendChild(ver);
      caixa.appendChild(lugar);
    }
    caixa.appendChild(el('div', { style: { fontSize: '13px', color: '#374151', lineHeight: '1.45', marginBottom: '10px', whiteSpace: 'pre-wrap' } }, c.descricao || ''));
    if (resolvida) {
      caixa.appendChild(el('div', { style: { fontSize: '11px', color: '#059669', fontWeight: '600' } },
        `Resolvida em ${quando(c.fechado_em)}`, c.fechado_por_nome ? ` por ${c.fechado_por_nome}` : '',
        c.fechado_obs ? ` — ${c.fechado_obs}` : ''));
    } else {
      caixa.appendChild(el('div', { style: { display: 'flex', gap: '6px', flexWrap: 'wrap' } },
        el('div', { style: { fontSize: '12px', color: '#6b7280', marginRight: 'auto', alignSelf: 'center' } }, 'Resolvida?'),
        el('button', { type: 'button', class: 'btn btn-secondary btn-sm', dataset: { nao: c.id },
          style: { fontSize: '12px', background: '#fff', borderColor: '#fca5a5', color: '#dc2626', fontWeight: '700' } }, 'Não'),
        el('button', { type: 'button', class: 'btn btn-primary btn-sm', dataset: { sim: c.id },
          style: { fontSize: '12px', background: '#16a34a', borderColor: '#15803d', fontWeight: '700' },
          onclick: () => confirmar(c) }, 'Sim')));
    }
    return caixa;
  }

  // "Sim pede observação" (Hugo, 02/11). Opcional, como em `resolver_chamado`.
  function confirmar(c) {
    const obs = el('textarea', { class: 'input', id: 'intercorrencia-obs', rows: '3', placeholder: 'O que foi feito? (opcional)' });
    const botao = el('button', { type: 'button', class: 'btn btn-verde', id: 'btn-confirmar-intercorrencia' }, 'Marcar como resolvida');
    botao.onclick = async () => {
      botao.disabled = true;
      try { await auth.rpc('resolver_chamado', { p_chamado: c.id, p_obs: obs.value.trim() || null }); }
      catch (e) { aviso(e.message, 'erro'); botao.disabled = false; return; }
      fecharModal();
      aviso(`Quarto ${c.unidade}: intercorrência resolvida.`, 'ok');
      if (aoMudar) aoMudar();
    };
    abrirModal(el('div', { id: 'resolver-intercorrencia', dataset: { chamado: c.id } },
      el('div', { class: 'modal-title' }, `Resolvida — Quarto ${c.unidade}`),
      el('div', { style: { fontSize: '13px', color: '#374151', marginBottom: '10px' } }, c.descricao || ''),
      el('label', { class: 'label', for: 'intercorrencia-obs' }, 'Observação'), obs,
      el('div', { class: 'acoes' },
        el('button', { type: 'button', class: 'btn btn-secondary', onclick: () => abrirIntercorrencias({ auth, linhas, aoMudar }) }, 'Voltar'),
        botao)));
  }

  function lista(itens, vazio, corVazio, fundoVazio) {
    return el('div', { style: { maxHeight: '60vh', overflowY: 'auto', WebkitOverflowScrolling: 'touch' } },
      itens.length ? itens.map(cartao)
        : [el('div', { class: 'vazio-intercorrencias', style: { padding: '20px', textAlign: 'center', color: corVazio, background: fundoVazio, borderRadius: '8px', fontSize: '13px' } }, vazio)]);
  }
  const rodape = () => el('div', { style: { display: 'flex', gap: '8px', marginTop: '14px' } },
    el('button', { type: 'button', class: 'btn btn-secondary', style: { flex: '1' }, onclick: () => fecharModal() }, 'Fechar'));
  const titulo = (cor, icn, texto, n, fundo, botao) => el('h2', { class: 'modal-title', style: { display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between', flexWrap: 'wrap' } },
    el('span', { style: { display: 'inline-flex', alignItems: 'center', gap: '8px', color: cor } }, ic(icn, 18, { color: cor }), texto,
      el('span', { style: { background: fundo, color: cor, fontSize: '12px', borderRadius: '10px', padding: '2px 9px' } }, String(n))),
    botao);

  function historico() {
    abrirModal(el('div', { id: 'intercorrencias-historico' },
      titulo('#059669', 'ic-check', 'Histórico de Intercorrências', resolvidas.length, '#dcfce7',
        el('button', { type: 'button', class: 'btn btn-secondary btn-sm', style: { fontSize: '12px' }, onclick: pendentesModal },
          ic('ic-undo', 13, { verticalAlign: '-2px', marginRight: '4px' }), 'Voltar para pendentes')),
      lista(resolvidas, 'Nenhuma intercorrência arquivada ainda.', '#6b7280', 'transparent'),
      rodape()));
  }
  function pendentesModal() {
    abrirModal(el('div', { id: 'intercorrencias' },
      titulo('#dc2626', 'ic-warning', 'Intercorrências Pendentes', pendentes.length, '#fee2e2',
        el('button', { type: 'button', class: 'btn btn-secondary btn-sm', id: 'btn-intercorrencias-historico', style: { fontSize: '12px' }, onclick: historico },
          ic('ic-relatorios', 13, { verticalAlign: '-2px', marginRight: '4px' }), `Histórico (${resolvidas.length})`)),
      lista(pendentes, 'Sem intercorrências pendentes — tudo certo nos quartos.', '#059669', '#ecfdf5'),
      rodape()));
  }
  pendentesModal();
}
